<crm-single-select
  #singleSelectComponent
  [options]="currencies"
  [(selectedItem)]="_selectedCurrency"
  (selectedItemChange)="onSelect($event)"
  [label]="labelInput ? 'Валюта' : ''"
  [disabled]="disabled"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [virtualScroll]="true"
  [virtualScrollItemSize]="35"
  [isTemplateCombined]="true"
  (onShow)="onShowPanel()"
  (onFilter)="search($event.filter)"
  [showClear]="showClear"
  [appendTo]="appendTo"
  filterBy="name,isoCharacter">
  <ng-template
    #itemTemplate
    let-currency="item">
    <div *ngIf="toCurrency(currency) as currency">
      <p>
        <span [innerHTML]="highlightMatchText(currency.name) | safeHtml"></span>
      </p>
      <p class="frm-color-green text-sm">{{ currency.isoCharacter }}</p>
    </div>
  </ng-template>
  <ng-template #footerTemplate>
    <crm-spinner
      *ngIf="paginationLoading"
      top=""
      text=""
      [height]="35"
      [width]="35"
      bottom=""></crm-spinner>
  </ng-template>
</crm-single-select>
